import React from 'react';
import { useLoader, usePopup, useToast } from '../../../hooks';
import { FloatingNavigationMenu, Loading, Popup, Snackbar } from '../..';
import { Container } from './styles';

type Props = {
    children: React.ReactNode;
}

const HomeLayout: React.FC<Props> = ({ children }) => {
    const { loading } = useLoader();
    const { toast } = useToast();
    const { popup } = usePopup();

    return (
        <>
            {loading && (
                <Loading loading={loading} />
            )}
            {toast && (
                <Snackbar
                    layout="auth"
                    {...toast}
                />
            )}
            {popup && (
                <Popup {...popup} />
            )}
            <Container>
                {children}
            </Container>
            <FloatingNavigationMenu />
        </>
    );
};

export { HomeLayout };
